import { combineReducers } from "redux";
import solutionsMainReducer from "./solutionsMainPage/solutionsMain.reducer";

const solutionsReducer = combineReducers({
  solutionsMainReducer,
});

export default solutionsReducer;
